import * as d3 from 'd3';
import * as topojson from 'topojson';
import { swoopyDrag } from 'd3-swoopy-drag';

const texasData = require('../assets/texas.json');
const cityData = window.data.bycity.sort(
  (a, b) => b['children'] - a['children']
);
const regionData = window.data.byregion;

let margin = { top: -15, bottom: 0, right: 0, left: 0 };
const chart = shelterschart();
const el = d3.select('#shelters-chart');
const breakpoint = 450;
let width = 0;
let height = 0;
let chartWidth = 0;
let chartHeight = 0;

let projection = d3
  .geoConicConformal()
  .parallels([32 + 8 / 60, 33 + 58 / 60])
  .rotate([98 + 30 / 60, 0]);

let path = d3.geoPath();

let ratio = 0.96151199165;

let circleScale = d3.scaleSqrt();
let fontScale = d3.scaleLinear();
let rightMarginScale = d3
  .scaleLinear()
  .domain([320, 1000])
  .range([60, 30]);

let leftMarginScale = d3
  .scaleLinear()
  .domain([320, 1000])
  .range([7.5, 15]);

let heightScale = d3
  .scaleLinear()
  .domain([320, 450])
  .range([1.2, 1]);

// let bottomMarginScale = d3
//   .scaleLinear()
//   .domain([325, 1000])
//   .range([-35, 15]);

let wrapScale = d3
  .scaleLinear()
  .domain([450, 1000])
  .range([130, 220]);

const formatChildren = d3.format(',');

const borderLabels = [
  {
    lat: 26.544575,
    lng: -98.784007,
    path: 'M-27,-39C-17,-18,4,-5,29,-2',
    text: 'Texas',
    textOffset: [43, 11],
  },
  {
    lat: 25.944485,
    lng: -99.467677,
    path: 'M-27,-39C-17,-18,4,-5,29,-2',
    text: 'Mexico',
    textOffset: [43, 11],
  },
];

function resize() {
  const bbox_width = document
    .getElementById('shelters-chart')
    .getBoundingClientRect().width;
  const width = bbox_width > 1000 ? 1000 : bbox_width;
  const height =
    window.innerWidth > breakpoint ? width : width * heightScale(width);
  //let chartWidth =
  margin = {
    top: 0,
    bottom: window.innerWidth > breakpoint ? 0 : 25,
    right: rightMarginScale(width),
    left: leftMarginScale(width),
  };
  chart.width(width).height(height);
  el.call(chart);
}

function shelterschart() {
  function enter({ container, data }) {
    const svg = container.selectAll('svg').data([data]);
    const svgEnter = svg
      .enter()
      .append('svg')
      .attr('class', 'shelters-svg');

    svgEnter
      .append('marker')
      .attr('id', 'arrow')
      .attr('viewBox', '-10 -10 20 20')
      .attr('markerWidth', 20)
      .attr('markerHeight', 40)
      .attr('orient', 'auto')
      .append('path')
      .attr('d', 'M0,-3L10,0L0,3');

    const gEnter = svgEnter.append('g').attr('class', 'parent-g');
    const defs = svgEnter.append('defs').attr('class', 'defs');
    gEnter.append('g').attr('class', 'state-g');
    gEnter.append('g').attr('class', 'urban-areas-g');
    gEnter.append('g').attr('class', 'roads-g');
    gEnter.append('g').attr('class', 'shelters-g');
    gEnter.append('g').attr('class', 'regions-g');
    gEnter.append('g').attr('class', 'legend');
    gEnter.append('g').attr('class', 'annotations');
    gEnter.append('g').attr('class', 'swoopies');
  }

  function updateScales({ container, data }) {
    const svg = container.select('svg');
    const g = svg.select('.parent-g');
    const legend = svg.select('.legend');

    circleScale
      .domain([0, d3.max(cityData, d => d['children'])])
      .range([0, width / 30]);

    fontScale.domain([320, 1000]).range([11.5, 16]);
  }

  function updateDom({ container, data }) {
    const svg = container.select('svg');

    svg.attr('width', width).attr('height', height);

    const g = svg.select('.parent-g');
    const defs = svg.select('.defs');
    g.attr('transform', `translate(${margin.left}, -5)`);

    const stateg = g.select('.state-g');
    const urban_areasg = g.select('.urban-areas-g');
    const roadsg = g.select('.roads-g');
    const sheltersg = g.select('.shelters-g');
    const regionsg = g.select('.regions-g');
    const legend = g.select('.legend');
    const annotationsg = g.select('.annotations');
    const swoopies = g.select('.swoopies');

    // [
    //   {
    //     "lat": 31.4454,
    //     "lng": -106.0883,
    //     "path": "M17,-89C2,-64,1,-22,2,-10",
    //     "text": "The temporary tent shelter at Tornillo, which held more than 2,700 children in December, was closed in early January.",
    //     "textOffset": [
    //       -9,
    //       -179
    //     ]
    //   }
    // ]

    const annotations = [
      {
        lat: 31.4454,
        lng: -106.0883,
        path: '',
        text:
          'The temporary tent shelter at Tornillo, which held more than 2,700 children in December, was closed in early January.',
        textOffset: [-9, window.innerWidth > breakpoint ? -179 : 47],
      },
    ];

    window.annotations = annotations;

    projection.fitExtent(
      [[0, 0], [chartWidth, chartHeight]],
      topojson.feature(data, data.objects.state)
    );

    path.projection(projection);

    const state = stateg
      .selectAll('.state')
      .data(topojson.feature(data, data.objects.state).features);

    state
      .enter()
      .append('path')
      .attr('class', 'state')
      .merge(state)
      .attr('d', path);

    const urban_area = urban_areasg
      .selectAll('.urban-area')
      .data(topojson.feature(data, data.objects.urban_areas).features);

    urban_area
      .enter()
      .append('path')
      .attr('class', 'urban-area')
      .merge(urban_area)
      .attr('d', path);

    const road = roadsg
      .selectAll('.road')
      .data(topojson.feature(data, data.objects.roads).features);

    road
      .enter()
      .append('path')
      .attr('class', 'road')
      .merge(road)
      .attr('d', path);

    const shelter = sheltersg.selectAll('.shelter').data(cityData);

    shelter
      .enter()
      .append('circle')
      .attr(
        'class',
        d => `shelter shelter-${d['city'].toLowerCase().replace(/\s+/g, '-')}`
      )
      .merge(shelter)
      .attr(
        'transform',
        d =>
          `translate(${projection([d['lng'], d['lat']])[0]}, ${
            projection([d['lng'], d['lat']])[1]
          })`
      )
      .attr('r', d => circleScale(d['children']));

    const regiong = regionsg.selectAll('.region-g').data(regionData);

    const regionGEnter = regiong
      .enter()
      .append('g')
      .attr('class', 'region-g');

    regionGEnter
      .append('text')
      .attr('class', 'region-text')
      .text(d => `${d['region_name']} area`)
      .attr('text-anchor', d => d['anchor']);

    regionGEnter
      .append('text')
      .attr('class', 'region-children')
      .attr('dy', '1.1em')
      .text(d => `${formatChildren(d['children'])} children`)
      .attr('text-anchor', d => d['anchor']);

    regionGEnter
      .append('text')
      .attr('class', 'region-shelter')
      .attr('dy', '2.2em')
      .text(d => `in ${d['shelters']} shelter${d['shelters'] == 1 ? '' : 's'}`)
      .attr('text-anchor', d => d['anchor']);

    const regionGUpdate = regionGEnter.merge(regiong);
    regionGUpdate.attr('transform', function(d) {
      return `translate(${projection([d['lng'], d['lat']])[0]}, ${projection([
        d['lng'],
        d['lat'],
      ])[1] -
        d3
          .select(this)
          .node()
          .getBoundingClientRect().height /
          4})`;
    });

    regionGUpdate
      .select('.region-text')
      .attr('x', d => chartWidth / d['textoffset'])
      .attr('font-size', fontScale(width));

    regionGUpdate
      .select('.region-children')
      .attr('x', d => chartWidth / d['textoffset'])
      .attr('font-size', fontScale(width));

    regionGUpdate
      .select('.region-shelter')
      .attr('x', d => chartWidth / d['textoffset'])
      .attr('font-size', fontScale(width));

    const legendDescG = legend
      .selectAll('.legend-description-g')
      .data(['Children in Texas shelters by city']);

    const legendDescGEnter = legendDescG
      .enter()
      .append('g')
      .attr('class', 'legend-description-g');

    legendDescGEnter
      .append('text')
      .attr('class', 'legend-description')
      .attr('dy', '1.2em')
      .text(d => d)
      .call(wrap, 150);

    const legendDescGUpdate = legendDescGEnter.merge(legendDescG);
    const legendDescHeight = legendDescGUpdate.node().getBoundingClientRect()
      .height;
    legendDescGUpdate.attr(
      'transform',
      `translate(${circleScale(d3.max(cityData, d => d['children']) / 2)}, ${
        window.innerWidth > breakpoint
          ? circleScale(d3.max(cityData, d => d['children'])) / 2 - legendDescHeight / 2
          : circleScale(d3.max(cityData, d => d['children'])) / 2 - (legendDescHeight * 3) / 4
      })`
    );
    legendDescGUpdate
      .select('.legend-description')
      .attr('font-size', fontScale(width));

    const legendg = legend.selectAll('.legend-g').data([20, d3.max(cityData, d => d['children'])]);

    const legendGEnter = legendg
      .enter()
      .append('g')
      .attr('class', 'legend-g');

    legendGEnter.append('circle').attr('class', 'legend-circle');

    legendGEnter
      .append('text')
      .attr('class', 'legend-text')
      .text((d, i) => `${i == 0 ? 'Fewer than' : 'At least'} ${formatChildren(d)}`)
      .attr('text-anchor', 'middle'/*(d, i) => (i == 0 ? 'end' : 'middle')*/)
      .attr('dy', '1em')
      .call(wrap, 60);

    const legendGUpdate = legendGEnter.merge(legendg);

    legendGUpdate.attr(
      'transform',
      (d, i) => `translate(${circleScale(2000) * 2 * i}, ${circleScale(2000)})`
    );
    legendGUpdate
      .select('.legend-circle')
      .attr('r', d => circleScale(d))
      .attr('cy', (d, i) => (i == 0 ? circleScale(d3.max(cityData, d => d['children'])) - circleScale(20) : 0));

    legendGUpdate
      .select('.legend-text')
      .attr(
        'transform',
        (d, i) =>
          `translate(${i == 0 ? circleScale(d) : 0}, ${circleScale(500)})`
      )
      .attr('font-size', fontScale(width));

    const legendWidth = legend.node().getBoundingClientRect().width;
    const legendHeight = legend.node().getBoundingClientRect().height;
    legend.attr(
      'transform',
      `translate(${
        window.innerWidth > breakpoint ? width * 0.2 : width * 0.75
      }, ${window.innerWidth > breakpoint ? height * 0.75 : height * 0.075})`
    );

    // const tornilloChildren = cityData.filter(d => d['city'] == 'Tornillo')[0][
    //   'children'
    // ];
    // const swoopy = swoopyDrag()
    //   .x(d => projection([d['lng'], d['lat']])[0] - 5)
    //   .y(
    //     d =>
    //       projection([d['lng'], d['lat']])[1] +
    //       (window.innerWidth > breakpoint
    //         ? -circleScale(tornilloChildren)
    //         : circleScale(tornilloChildren))
    //   )
    //   .draggable(false)
    //   .annotations(annotations);

    // swoopies.call(swoopy);
    // swoopies
    //   .selectAll('g')
    //   .selectAll('path')
    //   .attr('marker-end', 'url(#arrow)');
    // swoopies
    //   .selectAll('g')
    //   .selectAll('text')
    //   .attr('dy', '1.2em')
    //   .attr('font-size', fontScale(width))
    //   .call(wrap, window.innerWidth > breakpoint ? wrapScale(width) : 100);
    // const pathDef = defs.selectAll('.path-def').data(borderLabels);

    // pathDef
    //   .enter()
    //   .append('path')
    //   .attr('id', d => `${d['text']}-path`)
    //   .attr('class', 'path-def')
    //   .merge(pathDef)
    //   .attr('d', d => d['path']);

    const annotationG = annotationsg
      .selectAll('.annotation-g')
      .data(borderLabels);

    const annotationGEnter = annotationG
      .enter()
      .append('g')
      .attr('class', 'annotation-g');

    annotationGEnter
      .append('text')
      .append('textPath')
      .attr('class', 'text-path')
      .attr('xlink:href', d => `#${d['text']}-path`)
      .text(d => d['text']);

    const annotationGUpdate = annotationGEnter.merge(annotationG);

    annotationGUpdate.attr(
      'transform',
      d =>
        `translate(${projection([d['lng'], d['lat']])[0]}, ${
          projection([d['lng'], d['lat']])[1]
        })`
    );

    annotationGUpdate
      .select('.text-path')
      .attr('font-size', fontScale(width) * 0.75);
  }

  function chart(container) {
    const data = container.datum();
    enter({ container, data });
    updateScales({ container, data });
    updateDom({ container, data });
  }

  chart.width = function(...args) {
    if (!args.length) return width;
    width = args[0];
    chartWidth = width - margin.left - margin.right;

    return chart;
  };

  chart.height = function(...args) {
    if (!args.length) return height;
    height = args[0];
    chartHeight = height - margin.top - margin.bottom;
    return chart;
  };
  return chart;
}

function init() {
  el.datum(texasData);
  resize();
  window.addEventListener('resize', resize);
}

init();

function wrap(text, width) {
  text.each(function() {
    var text = d3.select(this),
      words = text
        .text()
        .split(/\s+/)
        .reverse(),
      word,
      line = [],
      lineNumber = 0,
      lineHeight = 1.1,
      x = text.attr('x'),
      y = text.attr('y'),
      dy = parseFloat(text.attr('dy')),
      tspan = text
        .text(null)
        .append('tspan')
        .attr('x', 0)
        .attr('y', y)
        .attr('dy', dy + 'em');
    while ((word = words.pop())) {
      line.push(word);
      tspan.text(line.join(' '));
      if (tspan.node().getComputedTextLength() > width) {
        line.pop();
        tspan.text(line.join(' '));
        line = [word];
        tspan = text
          .append('tspan')
          .attr('x', 0)
          .attr('y', y)
          .attr('dy', lineNumber * lineHeight + dy + 'em')
          .text(word);
      }
    }
  });
}



// WEBPACK FOOTER //
// ./shelters-map.js